import { Fragment, jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { cx } from "@/lib/cx";
import { RuiIconCalendar } from "@/lib/icons";
import { RuiCalendar } from "../calendar";
import "./date-range-picker.script";
export function RuiDateRangePickerControl({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-date-range-picker", className),
    children: /* @__PURE__ */jsx("div", {
      class: "rui-date-range-picker__group",
      children
    })
  });
}
export function RuiDateRangePickerInputs({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-date-range-picker__values", className),
    children
  });
}
export function RuiDateRangePickerStartInput({
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("input", {
    ...props,
    type: "text",
    "data-range-start": true,
    "data-rui-control": true,
    "data-rui-control-type": "text",
    class: cx("rui-date-range-picker__input", className),
    autocomplete: "off"
  });
}
export function RuiDateRangePickerEndInput({
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("input", {
    ...props,
    type: "text",
    "data-range-end": true,
    "data-rui-control": true,
    "data-rui-control-type": "text",
    class: cx("rui-date-range-picker__input", className),
    autocomplete: "off"
  });
}
export function RuiDateRangePickerSeparator({
  children = "\u2013",
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-date-range-picker__separator", className),
    "aria-hidden": "true",
    children
  });
}
export function RuiDateRangePickerToggle({
  children,
  class: className,
  aria,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    aria: withDefaultAriaLabel(aria, "Open calendar"),
    type: "button",
    "data-ref": "trigger",
    "data-range-trigger": true,
    class: cx("rui-control-toggle", className),
    "aria-haspopup": "dialog",
    children: children ?? /* @__PURE__ */jsx(RuiIconCalendar, {})
  });
}
export function RuiDateRangePickerPopover({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-ref": "popover",
    "data-range-popover": true,
    class: cx("rui-date-range-picker__popover rui-popover rui-floating", className),
    hidden: true,
    role: "dialog",
    children
  });
}
export function RuiDateRangePickerCalendar(props) {
  return /* @__PURE__ */jsx(RuiCalendar, {
    ...props,
    "data-range-calendar": true
  });
}
export function RuiDateRangePicker({
  children,
  startLabel = "Start date",
  endLabel = "End date",
  ...props
}) {
  return /* @__PURE__ */jsx("rui-date-range-picker", {
    ...props,
    children: children ?? /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsxs(RuiDateRangePickerControl, {
        children: [/* @__PURE__ */jsxs(RuiDateRangePickerInputs, {
          children: [/* @__PURE__ */jsx(RuiDateRangePickerStartInput, {
            "aria-label": startLabel
          }), /* @__PURE__ */jsx(RuiDateRangePickerSeparator, {}), /* @__PURE__ */jsx(RuiDateRangePickerEndInput, {
            "aria-label": endLabel
          })]
        }), /* @__PURE__ */jsx(RuiDateRangePickerToggle, {})]
      }), /* @__PURE__ */jsx(RuiDateRangePickerPopover, {
        children: /* @__PURE__ */jsx(RuiDateRangePickerCalendar, {})
      })]
    })
  });
}